<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-panel" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">
						<i class="sk-icon-door-open-solid"></i>
						Foodhall Pickup
					</h1>
					<button
						class="modal-close"
						aria-label="Close"
						@click="close"
					>
						<i class="sk-icon-times"></i>
					</button>
				</div>
				<div class="modal-body">
					<div class="modal-subtitle">
						Do you need any special accomodations?
					</div>
					<div class="flex-container" @click="setAccessibilityType(accessibilityTypes.IS_NOT_ACCESSIBLE_PICKUP)">
						<SkRadio
							:option="accessibilityTypes.IS_NOT_ACCESSIBLE_PICKUP"
							v-model="accessibilityType"
							class="checkbox-circle"
						/>
						<div class="checkbox-options">
							<span class="checkbox-option-text">
								Standard Pickup
							</span>
							<br />
							<span class="checkbox-option-description">
								The kitchen staff will put your food in the
								first available locker
							</span>
						</div>
					</div>
					<div class="flex-container" @click="setAccessibilityType(accessibilityTypes.IS_ACCESSIBLE_PICKUP)">
						<SkRadio
							:option="accessibilityTypes.IS_ACCESSIBLE_PICKUP"
							v-model="accessibilityType"
							class="checkbox-circle"
						/>
						<div class="checkbox-options">
							<span class="checkbox-option-text">
								Accessible Pickup
							</span>
							<br />
							<span class="checkbox-option-description">
								The kitchen staff will put your food in an
								accessible, easy to reach, locker
							</span>
						</div>
					</div>
					<button
						class="button button-primary"
						@click="updateFoodhallPickup"
					>
						Select Foodhall Pickup
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	align-items: flex-start;
	padding: 20px 5px;
}

.modal-header {
	height: 55px;
	border: 1px solid var(--sk-white2);
}

.modal-subtitle {
	font-size: 12px;
	margin-bottom: 47px;
	margin-left: 15px;

	height: 15px;

	font-style: normal;
	font-weight: 400;

	line-height: 15px;
}

.modal-subtitle,
.checkbox-option-text {
	font-size: 12px;
	margin-bottom: 47px;
	height: 15px;
	font-weight: 700;
	line-height: 15px;
}

.checkbox-option-description {
	font-weight: 400;
	font-size: 10px;
	line-height: 13px;
	height: 15px;
	font-weight: 400;
	font-style: italic;
}

.checkbox-options {
	margin-bottom: 20px;
	margin-left: -10px;
}

.checkbox-circle {
	margin-top: 10px;
	margin-left: 10px;
}

.flex-container {
	display: flex;
	margin-bottom: 20px;
}

.sk-select {
	margin-bottom: 60px;
}

.modal-body button.button.button-primary {
	max-width: calc(100% - 5px);
	margin: 0 5px;
}
</style>

<script>
import { AccessibilityType } from "@/enums/AccessibilityType"
import SkRadio from "@/components/common/SkRadio.vue"
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"

export default {
	name: "FoodhallPickupModal",
	mixins: [currencyFilterMixin, mobileResponsivenessMixin],
	components: {
		SkRadio
	},
	data: function () {
		return {
			accessibilityTypes: AccessibilityType,
			deliveryModes: DeliveryMode,
			accessibilityType: null
		}
	},
	computed: {
		modalToShow() {
			return this.$store.state.showModal
		},
	},
	methods: {
		setAccessibilityType(newVal){
			this.accessibilityType = newVal
			this.$store.dispatch("setAccessibility", newVal)
		},
		updateFoodhallPickup() {
			this.$store.dispatch("setAccessibility", this.accessibilityType)
			this.close()
		},
		async open() {
			if (this.modalToShow) {
				$(this.$refs.modal).modal("show")
				this.accessibilityType = this.$store.state.is_accessible_pickup
			}
		},
		close() {
			$(this.$refs.modal).modal("hide")
		},
		confirm() {
			this.close()
			this.consumePromise(true)
		}
	},
	mounted: function () {
		if (this.$store.getters.cartDeliveryModes && this.$store.getters.cartDeliveryModes.length == 1 && this.$store.getters.deliveryMode == this.deliveryModes.LOCKER) {
			this.open()
		}
	}
}
</script>
